import { defineComponent as y, useSlots as h, inject as k, computed as n, openBlock as i, createElementBlock as l, Fragment as x, createBlock as s, resolveDynamicComponent as a, mergeProps as B, withCtx as C, toRaw as D, createCommentVNode as d, renderSlot as u } from "vue";
import { ListVariantKey as I } from "@ds/components/TextList";
import { DefaultVariant as V } from "../TextList/TextList.constant.js";
import { tw as t } from "../../utils/tailwind.js";
const _ = {
  key: 0,
  class: "text-static-default-hi body-2 ml-40 list-none"
}, E = /* @__PURE__ */ y({
  name: "RevTextListItem",
  inheritAttrs: !1,
  __name: "TextListItem",
  props: {
    icon: { default: void 0 }
  },
  setup(r) {
    const f = r, c = h(), e = k(I), m = n(() => ({
      definition: "dt",
      ordered: "li",
      unordered: "li"
    })[e?.value || V]), b = n(() => !!(e?.value !== "ordered" && f.icon)), p = n(() => [
      t`text-static-default-hi relative mt-16 list-none first:mt-0`,
      e?.value === "definition" && t`body-1-bold`,
      e?.value !== "definition" && t`body-1`,
      e?.value === "ordered" && t`pl-40 [counter-increment:list-item] before:bg-static-default-mid before:body-2-bold before:absolute before:left-0 before:inline-flex before:size-24 before:shrink-0 before:items-center before:justify-center before:rounded-[50%] before:[content:counters(list-item,'.')]`,
      e?.value !== "ordered" && t`pl-40`
    ]), v = n(() => !!(e?.value === "definition" && c.definition));
    return (o, g) => (i(), l(x, null, [
      (i(), s(a(m.value), B({ class: p.value }, o.$attrs), {
        default: C(() => [
          b.value ? (i(), s(a(D(r.icon)), {
            key: 0,
            class: "absolute left-0 top-0"
          })) : d("", !0),
          u(o.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"])),
      v.value ? (i(), l("dd", _, [
        u(o.$slots, "definition")
      ])) : d("", !0)
    ], 64));
  }
});
export {
  E as default
};
